import styled from "styled-components";
import Table from "../DataTable";
import ActionButtons from "./ActionButtons";
import ListWithPagination from "../ListsWithPagination";
import LinkTextModal from "../LinkTextModal";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  data: {
    name: string;
    plate: string;
    istimara_photo: string;
    contact: string;
    car_type: string;
    car_model: string;
    car_photo: string;
    year: string;
    colour: string;
    fees: string;
  }[];
  isTableDataLoading: boolean;
  onApprove: (data: any) => void;
  onReject: (data: any) => void;
  totalData?: number;
  currentPage?: number;
  onPageChange: (page: number) => void;
}

const AlMahaDriveMembership = ({
  data,
  isTableDataLoading,
  onApprove,
  onReject,
  totalData = 0,
  currentPage = 1,
  onPageChange,
}: Props) => {
  const getLinkTextModal = (value: string, linkText: string) => (
    <LinkTextModal linkText={linkText} linkUrl={value} />
  );
  const getActionButtons = (data: any) => (
    <ActionButtons data={data} onApprove={onApprove} onReject={onReject} />
  );

  const columns = [
    {
      path: "name",
      label: "Name",
    },
    {
      path: "contact",
      label: "Contact",
    },
    {
      path: "plate",
      label: "Plate No.",
    },
    {
      path: "istimara",
      label: "Istimara",
      content: (data: any) =>
        getLinkTextModal(data.istimara_photo, "View Istimara"),
    },
    {
      path: "car_model",
      label: "Car",
    },
    {
      path: "car_photo",
      label: "Car Photo",
      content: (data: any) =>
        getLinkTextModal(data.car_photo, "View Car Photo"),
    },
    {
      path: "car_type",
      label: "Car Type",
    },
    {
      path: "year",
      label: "Year",
    },
    {
      path: "colour",
      label: "Colour",
    },
    {
      path: "fees",
      label: "Fees",
    },
    {
      label: "Action",
      path: "action",
      content: (data: any) => getActionButtons(data),
    },
  ];

  return (
    <>
      <TableWrapper>
        <TableWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          currentPage={currentPage}
          totalData={totalData}
          rowsPerPage={5}
          onPageChange={onPageChange}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={""}
          hidePagination={false}
          currentPage={currentPage}
          totalData={totalData}
          rowsPerPage={5}
          onPageChange={onPageChange}
        />
      </ListWrapper>
    </>
  );
};
const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    padding-top: 4.5rem;
    display: none;
  }
`;
const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default AlMahaDriveMembership;
